// extracted by mini-css-extract-plugin
export default {"Step5CompanyAddressTextForm":"Step5CompanyAddress_Step5CompanyAddressTextForm__xrICN","Step5CompanyAddressDiv":"Step5CompanyAddress_Step5CompanyAddressDiv__KsYV3"};